import React from 'react';
import { HeroProductCarousel } from './home/HeroProductCarousel';
import { useModal } from './ModalContext';
const primaryLinkClasses = 'inline-flex min-h-12 items-center justify-center rounded-xl bg-primary-700 px-7 py-3 text-base font-medium text-white shadow-sm transition-colors duration-200 hover:bg-primary-800 focus-visible:ring-primary-600';
export const Hero = () => {
  const {
    openTalkToUs
  } = useModal();
  return <section className="relative w-full overflow-hidden bg-gradient-to-br from-white via-primary-50/40 to-blue-50/40 pb-16 pt-12 sm:pt-16 md:pb-24 md:pt-20 lg:pb-28" data-id="element-139" data-mp="1285x3nzc5smb">
      <div className="pointer-events-none absolute -right-48 -top-48 h-[620px] w-[620px] rounded-full bg-gradient-to-br from-cyan-300/20 via-blue-200/15 to-transparent blur-3xl" data-id="element-140" data-mp="sarsqmqosuad" />
      <div className="pointer-events-none absolute -bottom-64 -left-48 h-[620px] w-[620px] rounded-full bg-gradient-to-tr from-amber-200/20 via-orange-100/15 to-transparent blur-3xl" data-id="element-141" data-mp="3d1ihv20l0yjq" />

      <div className="container relative" data-id="element-142" data-mp="384s5oprwen3l">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-10 xl:gap-14" data-id="element-143" data-mp="3j9kalakrlffl">
          <div className="lg:col-span-6" data-id="element-144" data-mp="3o7vk1k75dnxa">
            <div id="hero-logo" className="mb-9" data-id="element-145" data-mp="3o6u6n92nspce">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jP7ueorRtM9x7giMYpBsys/nisa-capriola-logotype.png" alt="Nisa" className="h-12 w-auto sm:h-14 md:h-16" data-id="element-146" data-mp="39aur5dd7zmx8" />
            </div>

            <h1 className="max-w-2xl text-balance font-serif text-[42px] font-medium leading-[1.04] tracking-[-0.025em] text-cyan-950 sm:text-[52px] lg:text-[56px] xl:text-[62px]" data-id="element-147" data-mp="30hhpnn13bczj">
              The everyday workspace for instructional coaching
            </h1>
            <p className="mt-5 text-xs font-semibold uppercase tracking-[0.18em] text-primary-700 sm:text-sm" data-id="element-148" data-mp="2qhqv5lcj4xzg">
              SCALING IMPACT IN K-12 SCHOOLS
            </p>
            <p className="mt-6 max-w-xl text-[17px] leading-[1.65] text-gray-600 md:text-lg" data-id="element-149" data-mp="2hkgh5s8buuqu">
              Nisa keeps observations, goals, evidence, and conversations
              connected around every teacher, so coaches return prepared and
              school teams can strengthen support over time.
            </p>

            <div className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-150" data-mp="n98d5mudb3nd">
              <button type="button" onClick={openTalkToUs} className={`${primaryLinkClasses} w-full sm:w-auto`} aria-haspopup="dialog" data-id="element-151" data-mp="ici0zaloos78">
                Request a demo
              </button>
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-152" data-mp="161t24t6y4olw">
            <div className="relative lg:w-[110%] xl:w-[115%]" data-id="element-153" data-mp="162ufj4bfpn6s">
              <HeroProductCarousel data-id="element-154" data-mp="112g55fmd215l" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};